module.exports = __webpack_public_path__ + "img/5_44.17e63e8b.png";